const IMPERSONATOR_TOKEN_KEY = 'fms_impersonator_token';
const IMPERSONATOR_ME_KEY = 'fms_impersonator_me';
const IMPERSONATOR_PERMISSIONS_KEY = 'fms_impersonator_permissions';
const IMPERSONATION_META_KEY = 'fms_impersonation_meta';

export type ImpersonationMeta = {
    target_user_id: number;
    target_name?: string;
    target_email?: string;
    impersonator?: { id: number; name: string; email: string } | null;
};

export function isImpersonating(): boolean {
    return Boolean(sessionStorage.getItem(IMPERSONATOR_TOKEN_KEY));
}

export function getImpersonationMeta(): ImpersonationMeta | null {
    try {
        const raw = sessionStorage.getItem(IMPERSONATION_META_KEY);
        return raw ? (JSON.parse(raw) as ImpersonationMeta) : null;
    } catch {
        return null;
    }
}

export function saveImpersonatorSession(
    token: string | null | undefined,
    me: unknown,
    permissions: unknown,
    meta: ImpersonationMeta,
): void {
    if (token) {
        sessionStorage.setItem(IMPERSONATOR_TOKEN_KEY, token);
    }
    if (me) {
        sessionStorage.setItem(IMPERSONATOR_ME_KEY, JSON.stringify(me));
    }
    if (permissions) {
        sessionStorage.setItem(IMPERSONATOR_PERMISSIONS_KEY, JSON.stringify(permissions));
    }
    sessionStorage.setItem(IMPERSONATION_META_KEY, JSON.stringify(meta));
}

export function clearImpersonatorSession(): void {
    sessionStorage.removeItem(IMPERSONATOR_TOKEN_KEY);
    sessionStorage.removeItem(IMPERSONATOR_ME_KEY);
    sessionStorage.removeItem(IMPERSONATOR_PERMISSIONS_KEY);
    sessionStorage.removeItem(IMPERSONATION_META_KEY);
}

export function restoreImpersonatorSession(): {
    token: string | null;
    me: unknown | null;
    permissions: unknown | null;
} {
    const token = sessionStorage.getItem(IMPERSONATOR_TOKEN_KEY);
    let me: unknown | null = null;
    let permissions: unknown | null = null;
    try {
        const rawMe = sessionStorage.getItem(IMPERSONATOR_ME_KEY);
        me = rawMe ? JSON.parse(rawMe) : null;
        const rawPerms = sessionStorage.getItem(IMPERSONATOR_PERMISSIONS_KEY);
        permissions = rawPerms ? JSON.parse(rawPerms) : null;
    } catch {
        me = null;
        permissions = null;
    }
    clearImpersonatorSession();
    return { token, me, permissions };
}
